import { CommonModule } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { CastService } from '../../services/cast.service'
import { EventService } from '../../services/event.service'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { CastQRCodeComponent } from './cast-qrcode/cast-qrcode.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { RouterService } from '../../services/router.service'
import { GoogleCastState } from '../../interfaces/local-googlecast'
import { CastErrorComponent } from './cast-error/cast-error.component'

@Component({
  selector: 'app-cast',
  standalone: true,
  imports: [CastQRCodeComponent, CommonModule, MatButtonModule, MatIconModule, TranslateModule, CastErrorComponent],
  templateUrl: './cast.component.html',
  styleUrls: ['./cast.component.scss'],
})
export class CastComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription()

  showLoading = true
  pairingPage = false
  readyToCastPage = false
  errorPage = false

  errorTitle = ''
  errorMessage = ''

  tvName!: string
  roomNumber!: string
  pairingStatus?: boolean

  constructor(
    private castService: CastService,
    private eventService: EventService,
    private routerService: RouterService,
    private translateService: TranslateService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerEventListener()
    this.tvName = this.castService.tvName
    this.roomNumber = this.castService.roomNumber

    this.subscriptions.add(
      this.castService.gcState$.subscribe((gcState?: GoogleCastState) => {
        if (gcState) {
          this.showLoading = gcState.isLoading
          if (!gcState.isReady || !gcState.isProxyReady) {
            const errorTitle = gcState?.errorTitle ?? this.translateService.instant('PAGES.CAST_ERROR.TITLE')
            const errorKey = gcState?.errorKey ?? 'MESSAGE'
            const errorMessage = this.translateService.instant(`PAGES.CAST_ERROR.${errorKey}`)
            this.showErrorPage(errorTitle, errorMessage)
            return
          }
        }

        if (gcState?.pairingStatus !== this.pairingStatus) {
          if (gcState?.pairingStatus) {
            this.pairingStatus = true
            this.showReadyToCastPage()
          } else {
            this.pairingStatus = false
            this.showPairingPage()
          }
        }

        if (!this.pairingPage && !this.readyToCastPage) {
          this.showPairingPage()
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.castService.stopCast()
    this.subscriptions?.unsubscribe()
  }

  registerEventListener(): void {
    this.subscriptions.add(
      this.eventService.keyDown.subscribe((key: string) => {
        switch (key) {
          case 'BACK':
            this.routerService.goBack()
            break
          default:
            break
        }
      })
    )
  }

  launchGoogleCastSettings(): void {
    this.castService.launchGoogleCastSettings()
  }

  done(): void {
    this.routerService.goToHome()
  }

  showPairingPage(): void {
    this.errorPage = false
    this.readyToCastPage = false
    this.pairingPage = true
  }

  showReadyToCastPage(): void {
    this.errorPage = false
    this.pairingPage = false
    this.readyToCastPage = true
  }

  showErrorPage(errorTitle: string, errorMessage: string): void {
    this.errorTitle = errorTitle
    this.errorMessage = errorMessage

    this.pairingPage = false
    this.readyToCastPage = false
    this.errorPage = true
  }

  doErrorBack(): void {
    this.showPairingPage()
  }

  doErrorClose(): void {
    this.routerService.goToHome()
  }
}
